import { ColumnOptions } from '../types/column-options';
import { DateTimeColumn } from '../types/grid';
import { IsoDateTime, IsoDateTimeTz } from '@softline/core';
import { ColumnHostRef } from '../types/refs';

export interface DateTimeColumnOptions<TRow extends object, TValue extends IsoDateTime | IsoDateTimeTz> extends ColumnOptions<TRow, TValue>{
  format?: string;
}

export function dateTimeColumn<TRow extends object, TValue extends IsoDateTime | IsoDateTimeTz>(
  ref: ColumnHostRef<TRow>,
  options: DateTimeColumnOptions<TRow, TValue>
): DateTimeColumn<TRow, TValue> {
  const column: DateTimeColumn<TRow, TValue> = {
    ...options,
    type: 'dateTime',
    format: options.format ?? 'DATE_TIME.DEFAULT',
  };
  ref.createColumn(column as any);
  return column;
}
